<template>
  <v-text-field
    label="Australian Business Number (ABN)"
    :value="value"
    @input="onInput"
    :rules="rules"
    :loading="loading"
    v-bind="$attrs"
  ></v-text-field>
</template>

<script>
import {
  validateAbn,
  cleanAbn
} from '../utilities'

export default {
  name: 'AbrSearchField',

  props: {
    value: String,
    loading: Boolean
  },

  computed: {
    rules () {
      const rules = []

      rules.push(v => validateAbn(v) || 'Invalid ABN')

      return rules
    }
  },

  methods: {
    onInput (value) {
      this.$emit('input', cleanAbn(value))
    }
  }
}
</script>
